import _default from './Icon';
export { _default as default };